import { render, staticRenderFns } from "./VehiclePageTable.vue?vue&type=template&id=7fb8694e&"
import script from "./VehiclePageTable.vue?vue&type=script&lang=js&"
export * from "./VehiclePageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports